import { BaseClient } from '@/api'

export class RoleClient extends BaseClient {
  constructor(
  ) {
    super('roles')
  }
}
